import logo from "../logo.svg";
import "../App.css";
import { useEffect } from "react";

function Bloomerang() {
    useEffect(() => {
        // remove charitystack-embed script
        const oldScript = document.getElementById("charitystack-embed");
        if (oldScript) {
            oldScript.remove();
        }
        // insert script tag
        const script = document.createElement("script");
        script.src = process.env.REACT_APP_CS_JS_SCRIPT;
        // add charitystack-embed as id
        script.id = "charitystack-embed";
        // set data-id to M_glZDDEVkfj
        script.dataset.id = "M_glZDDEVkfj";
        // make script defer
        script.defer = true;
        // append script to head
        document.body.appendChild(script);
    }, []);
    return (
        <div className="App">
            <div>This is some placeholder text above</div>

            <div data-entity="EMBED_FORM" data-source="CharityStack" id="84c112b2-f8e2-421e-b313-24f8898c8e86"></div>

            <div data-entity="EMBED_FORM" data-source="CharityStack" id="ca28d0fd-baf8-4954-a6d0-3edf7c9b2f51"></div>
            <div>This is some placeholder text below</div>
        </div>
    );
}

export default Bloomerang;
